import { API } from 'service/API'

import { IActivityFeedJSON, TIdType } from './ActivityFeedTypings'

export class ActivityFeedService {
  // @ts-expect-error TS(2564) FIXME: Property 'API' has no initializer and is not defin... Remove this comment to see the full error message
  API: API

  constructor(props) {
    Object.assign(this, props)
  }

  getActivities(
    shipmentId: string,
    params: { from: number; size: number; activityTypes: string[] }
  ): Promise<IActivityFeedJSON> {
    return this.API.customers.activityFeed.getActivities(shipmentId, params)
  }

  postMessage(shipmentId: string, requestBody: { type: string; content: string; userId: string }): Promise<void> {
    return this.API.customers.activityFeed.postMessage(shipmentId, requestBody)
  }

  addSubscriber = (shipmentId: string, id: string, idType: TIdType): Promise<void> => {
    return this.API.customers.activityFeed.addSubscriber(shipmentId, id, idType)
  }

  removeSubscriber = (shipmentId: string, id: string, idType: TIdType): Promise<void> => {
    return this.API.customers.activityFeed.removeSubscriber(shipmentId, id, idType)
  }
}
